"use strict";

exports.__esModule = true;
var Cep_1 = require("./validators/Cep");
exports.Cep = Cep_1.Cep;
var Cnpj_1 = require("./validators/Cnpj");
exports.Cnpj = Cnpj_1.Cnpj;
var Cpf_1 = require("./validators/Cpf");
exports.Cpf = Cpf_1.Cpf;
var CreditCard_1 = require("./validators/CreditCard");
exports.CreditCard = CreditCard_1.CreditCard;
var DateString_1 = require("./validators/DateString");
exports.DateString = DateString_1.DateString;
var Email_1 = require("./validators/Email");
exports.Email = Email_1.Email;
var Phone_1 = require("./validators/Phone");
exports.Phone = Phone_1.Phone;
var Pis_1 = require("./validators/Pis");
exports.Pis = Pis_1.Pis;
var Url_1 = require("./validators/Url");
exports.Url = Url_1.Url;
exports["default"] = {
  Cep: Cep_1.Cep,
  Cnpj: Cnpj_1.Cnpj,
  Cpf: Cpf_1.Cpf,
  CreditCard: CreditCard_1.CreditCard,
  DateString: DateString_1.DateString,
  Email: Email_1.Email,
  Phone: Phone_1.Phone,
  Pis: Pis_1.Pis,
  Url: Url_1.Url
};